
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import { ProviderRegistrationDialogComponent } from '../provider-registration-dialog/provider-registration-dialog.component';
import { ProviderRegistration } from '../../models/provider-registration.model';

@Component({
  selector: 'app-email-input',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule
],
  templateUrl: './email-input.component.html',
  styleUrl: './email-input.component.scss'
})
export class EmailInputComponent {
  @Input() disabled: boolean = false;
  @Output() emailSubmitted = new EventEmitter<string>();
  @Output() providerRegistrationRequested = new EventEmitter<ProviderRegistration>();
  
  private dialog = inject(MatDialog);
  emailForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit(): void {
    if (this.emailForm.valid) {
      this.emailSubmitted.emit(this.emailForm.value.email);
    }
  }

  onProviderRegistrationClick(): void {
    const dialogRef = this.dialog.open(ProviderRegistrationDialogComponent, {
      width: '700px',
      maxWidth: '90vw',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result: ProviderRegistration | undefined) => {
      if (result) {
        console.log('Provider registration data:', result);
        this.providerRegistrationRequested.emit(result);
        // Here you could show a success message or handle the registration
      }
    });
  }
}
